import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { cn } from '@/lib/utils';

export function BackToTop() {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 200) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <button
            onClick={scrollToTop}
            className={cn(
                "fixed bottom-8 right-8 z-40 flex h-12 w-12 items-center justify-center rounded-full border border-zinc-800 bg-zinc-900/80 text-brand-gold shadow-2xl backdrop-blur-md transition-all duration-500 hover:scale-110 active:scale-95 hover:border-brand-gold/50 hover:bg-zinc-800",
                isVisible
                    ? "translate-y-0 opacity-100 pointer-events-auto"
                    : "translate-y-10 opacity-0 pointer-events-none"
            )}
            aria-label="Вернуться наверх"
        >
            <ArrowUp className="h-6 w-6" />

            {/* Visual ring effect on hover */}
            <span className="absolute inset-0 rounded-full border border-brand-gold opacity-0 transition-opacity hover:opacity-20 animate-ping duration-[2000ms]" />
        </button>
    );
}
